export default {
    title: 'My hormonal health questions',
    score: [],
    text: 'As you read through this questions, check the symptoms that apply to you currently',
    language: 'FR / EN',
    icons: {
        title: 'mdi-checkbox-multiple-marked-outline',
        languages: 'mdi-earth',
    }
};
